import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconComponent, SpinnerComponent } from '@sarasanalytics-com/design-system';
import { Products } from 'src/app/interfaces/state-interface';
import { SplashScreenPage } from 'src/app/interfaces/webflow-details.interface';
import { WebflowService } from 'src/app/services/signup/webflow.service';
import { StoreService } from 'src/app/services/store/store.service';

@Component({
  selector: 'sa-welcome-view',
  standalone: true,
  imports: [
    IconComponent,
    SpinnerComponent
  ],
  templateUrl: './welcome-view.component.html',
  styleUrl: './welcome-view.component.scss'
})
export class WelcomeViewComponent {
  private webflowService: WebflowService = inject(WebflowService);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private store: StoreService = inject(StoreService);
  LoginSignupPage: SplashScreenPage = { pageTitle: '', pageSubtitle: '', pageSubTitle2: '' };
  webflowContentReady = false;

  ngOnInit() {
    const defaultProduct: Products = this.store.getProduct() as Products;
    this.webflowService.getSplashScreenPage$(defaultProduct)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((welcomeView) => {
        this.LoginSignupPage = welcomeView;
        this.webflowContentReady = true;
      });
  }
}
